import { PreferencesLoadingErrorModal } from 'components/Blotters/PriceImprovement/preferencesLoadingErrorModal';
import { ConnectedScheduledQuotesBlotter } from 'components/shared/ScheduledRun/Blotter/ScheduledQuotesBlotter';
import { FC } from 'react';

const ScheduledQuotesBlotter: FC = () => (
  <div className="scheduled-quotes-blotter-route-component page-container w-100 h-100">
    <PreferencesLoadingErrorModal>
      <ConnectedScheduledQuotesBlotter />
    </PreferencesLoadingErrorModal>
  </div>
);

export default ScheduledQuotesBlotter;
